/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies */
import Controller from '@ember/controller';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import Scopes from '@linc-technologies/linced-common/enums/scopes';

export default class InformationController extends Controller {
  // Services
  @service
  session;

  @service
  permissions;

  queryParams = ['selectedTab'];
  selectedTab = 0;

  // Methods
  /**
   * canSeeInfo computes whether the current user is able to see the info icon.
   */
  @computed('model.person.{id,type}')
  get canSeeInfo() {
    let person = this.get('model.person');
    if (this.session.personId === person.id) {
      return true;
    }

    switch (person.type) {
      case PersonType.LINC_ED:
        return false;

      case PersonType.STAFF:
        return this.permissions.meet(Scopes.TENANT_ADMIN);
    }

    return true;
  }
}
